const debug = false


const izr_server = debug ? "http://127.0.0.1:8000/sarah" : "https://izr-cloud.online/sarah"

export default izr_server